import { getCSRFToken } from "./htmx-helpers";
import { alpineData } from "./alpine-data";

export function registerFormBuilder(Alpine: any) {
  Alpine.data("formBuilder", (initialFields: any[], translations: any, saveUrl: string) => alpineData({
    fields: initialFields || [],
    selectedFieldId: null,
    dragging: false,
    t: translations,

    moveField(index: number, direction: number) {
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= this.fields.length) return;

      const item = this.fields.splice(index, 1)[0];
      this.fields.splice(newIndex, 0, item);
      this.updateDisplayOrder();
    },

    moveOption(index: number, direction: number) {
      if (!this.selectedField || !this.selectedField.options) return;
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= this.selectedField.options.length) return;
      const opt = this.selectedField.options.splice(index, 1)[0];
      this.selectedField.options.splice(newIndex, 0, opt);
    },

    updateDisplayOrder() {
      this.fields.forEach((f: any, index: number) => {
        f.display_order = index;
      });
    },

    addField(type: string) {
      const id = (window as any).crypto.randomUUID();
      const typeLabel = this.t["type_" + type] || type;
      const name = this.t.new_field_name.replace("{Type}", typeLabel);

      const newField = {
        _ui_id: id,
        id: null,
        name: name,
        field_type: type,
        is_required: false,
        placeholder: "",
        help_text: "",
        options: ["select", "multiselect"].includes(type)
          ? [{ label: this.t.new_option_name, value: "opt1" }]
          : null,
        display_order: this.fields.length,
      };
      this.fields.push(newField);
      this.selectField(newField._ui_id);
      this.$nextTick(() => {
        this.$refs.canvas.lastElementChild.scrollIntoView({ behavior: "smooth" });
      });
    },

    removeField(ui_id: string) {
      this.fields = this.fields.filter((f: any) => f._ui_id !== ui_id);
      if (this.selectedFieldId === ui_id) {
        this.selectedFieldId = null;
      }
    },

    selectField(ui_id: string) {
      this.selectedFieldId = ui_id;
    },

    get selectedField() {
      return this.fields.find((f: any) => f._ui_id === this.selectedFieldId);
    },

    addOption() {
      if (this.selectedField && this.selectedField.options) {
        this.selectedField.options.push({
          label: this.t.new_option_name,
          value: "opt" + (this.selectedField.options.length + 1),
        });
      }
    },

    removeOption(index: number) {
      if (this.selectedField && this.selectedField.options) {
        this.selectedField.options.splice(index, 1);
      }
    },

    save() {
      const payload = this.fields.map((f: any, index: number) => ({
        id: f.id,
        name: f.name,
        field_type: f.field_type,
        is_required: f.is_required,
        placeholder: f.placeholder,
        help_text: f.help_text,
        display_order: index,
        options: f.options,
      }));

      fetch(saveUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": getCSRFToken(),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (response.ok) {
            // Re-render the current page in place (no hard reload: keeps
            // the global uploader + hx-preserve'd widgets alive).
            (window as any).htmx.ajax("GET", window.location.pathname + window.location.search, {
              target: "body",
              swap: "innerHTML",
            });
          } else {
            alert(this.t.save_failed);
          }
        })
        .catch((err) => {
          console.error(err);
          alert(this.t.save_error);
        });
    },
  }));
}
